import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import SearchResultEntity from "../../entities/SearchResultEntity";
import QrBatchEntity from "../../entities/QrBatchEntity";
import QrRepository from "../../repositories/QrRepository";

interface _Props {
    qrRepository: QrRepository;
}

@injectable()
export default class SearchQrsUseCase {
    private qrRepository: QrRepository;

    constructor(props: _Props) {
        this.qrRepository = props.qrRepository;
    }

    public call = async (_:{stablishmentId?: string, page: number, itemsPerPage: number}): Promise<Either<ErrorEntity, SearchResultEntity<QrBatchEntity>>> => {
        return this.qrRepository.searchQrs(_);
    }
}

export const SearchQrsUseCaseName = "SearchQrsUseCase";